import React from 'preact';
import { useEffect } from "preact/compat";
import { useState } from "preact/hooks";
import constants from '../../constants';

interface TwoColumnsProps {
  active: boolean;
}

export default function TwoColumns({ active }: TwoColumnsProps) {
  const [primaryColor, setPrimaryColor] = useState('');
  const [secondaryColor, setSecondaryColor] = useState('');

  useEffect(() => {
    if (active) {
      setPrimaryColor(constants.PRICE_COLOR_PRIMARY_ACTIVE);
      setSecondaryColor(constants.PRICE_COLOR_PRIMARY_ACTIVE);
    } else {
      setPrimaryColor(constants.PRICE_COLOR_PRIMARY_INACTIVE);
      setSecondaryColor(constants.COLUMN_COLOR_SECONDARY_INACTIVE);
    }
  }, [active]);

  return (
    <svg viewBox="0 0 46 28" xmlns="http://www.w3.org/2000/svg">
        <g>
            <path fill={primaryColor} d="M20.696 8.385H.272c-.146 0-.272.141-.272.317v2.21c0 .177.126.318.272.318h20.424c.146 0 .272-.141.272-.317v-2.21c0-.177-.126-.318-.272-.318zM20.696 0H.272C.126 0 0 .14 0 .317v2.21c0 .177.126.318.272.318h20.424c.146 0 .272-.141.272-.317V.318c0-.177-.126-.318-.272-.318zM20.696 25.146H.272c-.146 0-.272.141-.272.317v2.211c0 .176.126.317.272.317h20.424c.146 0 .272-.14.272-.317v-2.21c0-.177-.126-.318-.272-.318zM20.696 16.761H.272c-.146 0-.272.141-.272.317v2.22c0 .176.126.317.272.317h20.424c.146 0 .272-.141.272-.317v-2.22c0-.176-.126-.317-.272-.317z" />
            <path fill={secondaryColor} d="M45.728 0H25.304c-.146 0-.272.14-.272.317v2.21c0 .177.126.318.272.318h20.424c.146 0 .272-.141.272-.317V.318C46 .14 45.874 0 45.728 0zM45.728 16.761H25.304c-.146 0-.272.141-.272.317v2.22c0 .176.126.317.272.317h20.424c.146 0 .272-.141.272-.317v-2.22c0-.176-.126-.317-.272-.317zM45.728 8.385H25.304c-.146 0-.272.141-.272.317v2.21c0 .177.126.318.272.318h20.424c.146 0 .272-.141.272-.317v-2.21c0-.177-.126-.318-.272-.318z" />
        </g>
    </svg>
  );
}